/**
 * Allow only same-origin relative paths for post-auth redirects.
 * Rejects absolute URLs, protocol-relative URLs (`//`), backslash tricks, and
 * control/whitespace characters that browsers may collapse into `//`.
 *
 * When `fallback` is omitted, invalid/missing paths fall back to `'/'`.
 * Pass `undefined` explicitly as `fallback` to return `undefined` instead.
 */
const UNSAFE_REDIRECT_CHAR_RE = /[\u0000-\u001F\u007F\s]/;

export function sanitizeRedirectPath(path: string | null | undefined, fallback?: string): string | undefined {
  const resolvedFallback = arguments.length >= 2 ? fallback : '/';

  if (!path) return resolvedFallback;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return resolvedFallback;
  if (trimmed.includes('\\') || UNSAFE_REDIRECT_CHAR_RE.test(trimmed)) return resolvedFallback;

  const collapsed = trimmed.replace(UNSAFE_REDIRECT_CHAR_RE, '');
  if (!collapsed.startsWith('/') || collapsed.startsWith('//')) return resolvedFallback;

  return trimmed;
}
